import React from 'react';
import SEO from '../shared/SEO';

export default function StaticPage({ title, children, description }) {
    return (
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <SEO title={title} description={description || `Learn more about ${title} at Host-it!`} />
            <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-gray-100">
                <h1 className="text-4xl font-extrabold text-gray-900 mb-8 border-b border-gray-100 pb-6 text-center tracking-tight">{title}</h1>
                <div className="prose prose-lg prose-pink max-w-none text-gray-700 leading-relaxed">
                    {children}
                </div>
            </div>
        </div>
    );
}